module.exports = {
  axios: {
    defaultTimeout: 60000,
  },
  loggingService: {
    enableRemoteLogging: false,
    enableConsole: true,
  },
  customerChat: {
    scriptUrl: '',
  },
  errorViewCssUrl: '', // Duplicated in server config
};
